/**
 * Moroccan dirham.
 */
export var MAD = {
  code: 'MAD',
  base: 10,
  exponent: 2
};